import { type FC } from 'react';
import { Typography } from '@mui/material';
import * as Styled from './styled';

export type Props = {
  label: string;
  hint?: string;
};

export const AutocompleteOptionWithHint: FC<Props> = ({ label, hint }) => (
  <Styled.Option>
    <Typography variant="body1" color="text.primary">
      {label}
    </Typography>
    {hint && (
      <Typography variant="body2" color="text.secondary">
        {hint}
      </Typography>
    )}
  </Styled.Option>
);
